<app-button-advanced
  [action]="brightnessAction"
  [active]="
    ['Wwwc'].includes((stateProjectManagerService.currentTool$ | async)!)
  "
  matTooltip="{{ 'viewer.Tools.Wwwc' | translate }}"
  [matTooltipPosition]="'left'"
  [matTooltipDisabled]="isDisabled$ | async"
>
</app-button-advanced>
